/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramSupportContactsControllerGetSubjectsQueryResponse,
  TelegramSupportContactsControllerGetSubjects401,
} from '../types/TelegramSupportContactsControllerGetSubjects.ts';

function getTelegramSupportContactsGetSubjectsUrl() {
  const res = { method: 'GET', url: `/api/telegram/support-contacts/subjects` as const };
  return res;
}

/**
 * {@link /api/telegram/support-contacts/subjects}
 */
export async function telegramSupportContactsGetSubjects(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramSupportContactsControllerGetSubjectsQueryResponse,
    ResponseErrorConfig<TelegramSupportContactsControllerGetSubjects401>,
    unknown
  >({ method: 'GET', url: getTelegramSupportContactsGetSubjectsUrl().url.toString(), ...requestConfig });
  return res.data;
}
